import React, {useState} from "react";
import telegram from "./assets/brand-telegram.svg";
import twitter from "./assets/twitterLogo.svg";
import youtube from "./assets/youtubeLogo.svg";
import thum from "../../Home/CardsStatusSection/assets/2.png";
import coin from "../../Home/CardsStatusSection/assets/coin.png";
import Card from "../Card/Card";
import AddRaiseModal from "../../../GlobalComponents/AddRaiseModal/ApplyModal";
import Popup from "reactjs-popup";
const Banner = () => {
  const [openBid, setOpenBid] = useState(false);
  const handleJoin = () =>{
    setOpenBid(true);
  }
  return (
    <div className="bg-custom-gradient pt-[43px] py-[42px]">
      <div className="container">
        <div className="container-1240">
          <div className="max-w-[1119px] ml-auto ">
            <div className="flex flex-col items-center lg:flex-row  gap-[70px] md:gap-[111px]">
              <div className="max-w-[608px]   w-full  grow">
                <h3 className="text-[28px] leading-[33px] font-bold text-main-black">
                  Featured
                </h3>
                <h1 className="text-res-lg text-main-black font-black mb-[6px]">
                  The Acquire.Fi Raise
                </h1>

                <p className="text-res-ls text-main-black mb-[16px] font-semibold">
                  Acquire.Fi is a Web3 M&A ecosystem where fractionalized
                  ownership of real world assets is being pioneered. Acquire.Fi,
                  now offers crowdfunding to help innovative web3 businesses
                  raise capital from a wider range of investors. With its
                  expertise in M&A & crowdfunding, Acquire.Fi is well-positioned
                  to support the growth of web3 companies.
                </p>

                <div className="flex flex-col sm:flex-row gap-[24px]">
                  <button onClick={handleJoin} className="bg-main-black  w-[173px] h-10 rounded-[20px] text-res-light-black font-bold ">
                    Join Raise
                  </button>

                  <div className="border rounded-[20px] border-solid px-[20px] pt-[10px] pb-[11px] border-main-black w-[271px] h-[40px] flex align-center">
                    <div className="flex gap-x-[25px] items-center">
                      <h4 className="text-res-xs text-main-black font-extrabold">
                        Our Socials
                      </h4>
                      <a href="https://t.me/acquire">
                        <img src={telegram} alt="" />
                      </a>
                      <a href="https://twitter.com/acquire">
                        <img src={twitter} alt="" />
                      </a>
                      <a href="https://youtube.com/acquire">
                        <img src={youtube} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-none ">
                <Card
                  {...{
                    thum,
                    access: "Tier 1 & 2",
                    participants: 266,
                    profile: coin,
                    title: "Acquire.Fi",
                    block: "Ethereum",
                    status: "in progress",
                    raisedAmountMin: "34,000",
                    raisedAmountMax: " 75,000 ETH",
                    progress: `${(34000 / 75000) * 100}%`,
                  }}
                ></Card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup open={openBid} position="right center">
        <div className="modalOverlay"></div>
        <AddRaiseModal
          open={openBid}
          setOpen={setOpenBid}
        ></AddRaiseModal>
      </Popup>
    </div>
  );
};

export default Banner;
